import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import useStore from "../store/useStore";
import HeroComexButton from "../components/HeroComexButton";
import EventCard from "../components/EventCard";

export default function Eventos() {
  const { eventoHeroes, getEventoHeroes, eventos, fetchEventos } = useStore();

  useEffect(() => {
    getEventoHeroes();
    fetchEventos();
  }, [getEventoHeroes, fetchEventos]);
  console.log("Evento Heroes:", eventoHeroes);

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <section>
          {eventoHeroes && eventoHeroes.length > 0
            ? eventoHeroes.map((item, index) => (
                <HeroComexButton
                  key={index}
                  video={item.video?.[0]?.url}
                  titulo={item.titulo}
                  logo={item.img?.[0]?.url}
                  buttonText={item.text}
                  buttonLink={item.url}
                  height="h-[350px]"
                />
              ))
            : null}
        </section>
        <section className="relative container overflow-hidden py-36 bg-sidom-light dark:bg-sidom-blue">
          <h3 className="font-extrabold text-left text-4xl md:text-5xl text-sidom-orange mb-[30px]">
            Eventos
          </h3>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
            {(eventos || []).map((item, index) => (
              <EventCard
                key={item.id || index}
                id={item.id}
                titulo={item.titulo}
                estado={item.estado}
                tipo={item.tipo_evento}
                image={
                  item.imagen && item.imagen[0]
                    ? item.imagen[0].formats.thumbnail.url
                    : ""
                }
                data={item.fecha_y_hora || ""}
                desc={
                  item.descripcion && item.descripcion[0]?.children
                    ? item.descripcion[0].children[0]?.text?.slice(0, 120) +
                      "..."
                    : ""
                }
              />
            ))}
          </div>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}
